/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ui = void 0;

var constants_1 = require("../constants");

var Ui = {
  closeModal: function closeModal() {
    return {
      type: constants_1.UI.CLOSE_MODAL
    };
  },
  lastSelection: function lastSelection(selection) {
    return {
      type: constants_1.UI.LAST_SELECTION,
      selection: selection
    };
  },
  openModal: function openModal(modalType, modalData) {
    return {
      type: constants_1.UI.OPEN_MODAL,
      modalType: modalType,
      modalData: modalData
    };
  },
  setActiveView: function setActiveView(activeView) {
    return {
      type: constants_1.UI.SET_ACTIVE_VIEW,
      activeView: activeView
    };
  },
  setCurrentCategory: function setCurrentCategory(currentCategoryId, shouldScrollToCategory) {
    return {
      type: constants_1.UI.CURRENT_CATEGORY,
      currentCategoryId: currentCategoryId,
      shouldScrollToCategory: shouldScrollToCategory
    };
  },
  setFullScreen: function setFullScreen(fullScreen) {
    return {
      type: constants_1.UI.SET_FULL_SCREEN,
      fullScreen: fullScreen
    };
  }
};
exports.Ui = Ui;